(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurala_stock-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aurala-stock-note')) {
    customElements.define('aurala-stock-note', class extends HTMLElement {
      static get observedAttributes() { return ['data-form']; }
      connectedCallback() {
        if (this.hasAttribute('data-static')) return;
        this.onChange = () => queueMicrotask(() => this.update());
        this.bind();
      }
      disconnectedCallback() {
        this.unbind();
      }
      attributeChangedCallback() {
        if (!this.isConnected || !this.onChange) return;
        this.unbind();
        this.bind();
      }
      bind() {
        const formId = this.dataset.form;
        this.form = formId ? document.getElementById(formId) : this.closest('form');
        this.owner = formId
          ? this.form?.closest('product-info') || this.form
          : this.closest('.aurala-picker__card, product-info') || this.form;
        this.owner?.addEventListener('change', this.onChange);
        this.update();
      }
      unbind() {
        this.owner?.removeEventListener('change', this.onChange);
        this.owner = null;
      }
      update() {
        if (this.dataset?.form && !this.form?.isConnected) this.form = document.getElementById(this.dataset.form);
        if (!this.form) return;
        const input = this.form.querySelector('[name="id"]');
        const id = input && !input.disabled ? input.value : '';
        let shown = false;
        this.querySelectorAll('[data-stock-variant]').forEach(note => {
          note.hidden = note.dataset.stockVariant !== id;
          if (!note.hidden && note.textContent.trim()) shown = true;
        });
        this.hidden = !shown;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
